const getDefaultProps = () => ({
  zIndex: 100,
  background: "#ffffff"
});
const getDefaultSlices = () => {
  return [];
};
const getDefaultMessage = () => {
  return "";
};
export {
  getDefaultMessage,
  getDefaultProps,
  getDefaultSlices
};
//# sourceMappingURL=getDefault.js.map
